export default __webpack_public_path__ + "static/media/me.38c4bcfd.png";